<template lang="pug">
#GPT.main-page.page-noScroll.pb-0.position-relative(v-if="!loading"  :class="is_private ? 'upportal-color' : 'GPT-color' ")
    loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999' attach)
    loadingOverlay(v-if='delLoading' message='Loading . . .' :zIndex='999' attach)
            v-progress-circular(indeterminate color='primary')
    div(v-if='!loading')
      // 返回知識庫總覽
      div(:href='"/upgpt/Knowledges"' v-if ="!is_private").d-flex.align-start.justify-start.pl-9
        v-breadcrumbs.pa-0.px-3.pb-2.ellipsis()
          v-breadcrumbs-item(v-for="item in breadcrumbs" :key="item.text")
            .detail_a
              a(:href='item.href')
                v-icon(size='23' style='margin-bottom:2px;').pr-1 mdi-chevron-double-left
                span {{item.text}}
      div.d-flex.align-start.justify-start.pl-9(v-else-if="is_private")
        v-breadcrumbs.pa-0.px-3.pb-2.ellipsis()
          v-breadcrumbs-item(v-for="item in breadcrumbs" :key="item.text"  @click.prevent="$emit('breadcrumbs-click')")
            .detail_a
              a(:href='item.href')
                v-icon(size='23' style='margin-bottom:2px;').pr-1 mdi-chevron-double-left
                span {{item.text}}
      // 知識庫設定區
      #page-inner.pa-3.d-flex.justify-center
            v-card.deal-tab-card.rounded-card(style='width:95%;' flat)
              v-row.account-info(no-gutters='no-gutters' align="center" justify="center")
                // 基礎設定區(左側)
                v-col(cols='6' md='6')
                    .knowledges-detail-card-text.pt-0.pb-3
                      v-card-text.mt-0.pa-0.knowledges-card-text()
                          v-form(v-model='valid' ref='form')
                            // 標題
                            v-row.mt-4(no-gutters :title='knowledgeData.display_name')
                              v-col.d-flex(cols='auto' ref="nameWidth")
                                  v-img(src="@/assets/images/book1.png" class="white--text align-end"  width="40px" contain)
                                  h4.pl-3.f-text-highlight-word.ellipsis.mt-2.pt-1() {{ knowledgeData.display_name }}
                            // 類別
                            v-row(no-gutters).mt-2
                              v-col.pr-md-4(cols='2').my-1
                                  label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('GPT_KNOWLEDGE.CATEGORY')}}
                              v-col.pa-0(cols='8' :title='knowledgeData.category')
                                  v-combobox.bg-white.hint-style(
                                    v-model='knowledgeData.category',
                                    height='30',
                                    dense,
                                    outlined,
                                    :readonly="!isEdit && !loading",
                                    :clearable="isEdit && !loading",
                                    :items='category_list',
                                    item-value='id',
                                    item-text='name',
                                    :rules='formRule.categoryRules',
                                    :hint=`$t('ADD_KNOWLEDGE.CATEGORY_HTNT')`
                                    persistent-hint
                                    style='font-weight: 500; font-size: 14px;'
                                  )
                              v-col.pa-0(cols='2')
                                  div.ml-5
                                    v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                    v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                    v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                    v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                            // System name
                            v-row(no-gutters).mt-6
                              v-col.pr-md-4(cols='2').my-1
                                  label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('GPT_KNOWLEDGE.SYSTEM_NAME_LABEL')}}
                              v-col.pa-0(cols='8' :title='knowledgeData.system_name')
                                  v-text-field.mb-6.hint-style(
                                    v-model="knowledgeData.system_name"
                                    :rules="formRule.system_nameRules"
                                    :readonly="!isEdit"
                                    persistent-hint
                                    :hint=`$t('GPT_KNOWLEDGE.SYSTEM_NAME_TIP')`
                                    dense
                                    outlined
                                    style='font-weight: 500; font-size: 14px;'
                                  )
                              v-col.pa-0(cols='2')
                                  div.ml-5
                                    v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                    v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                    v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                    v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                            // 描述
                            v-row(no-gutters).mt-3
                              v-col.pr-md-4(cols='2').my-1
                                  label {{$t('CONTACT_DETAIL.DESCRIPTION')}}
                              v-col.pa-0(cols='8' :title='knowledgeData.description')
                                  v-textarea.span.textarea-style.mb-6.hint-style(
                                    v-model='knowledgeData.description'
                                    :rules="formRule.descriptionRules"
                                    :readonly='!isEdit'
                                    no-resize
                                    rows='3'
                                    persistent-hint
                                    :hint=`$t('ADD_KNOWLEDGE.DESCRIPTION_HINT')`
                                    outlined
                                    style='font-weight: 500; font-size: 14px;'
                                  )
                                    template(v-slot:append)
                              v-col.pa-0(cols='2')
                                  div.ml-5
                                    v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                    v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                    v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                    v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                            // 父層（資料夾模式才顯示）
                            v-row(no-gutters v-if='folder_mode && !is_private')
                              v-col.pr-md-4(cols='2').my-1
                                  label {{$t('ADD_KNOWLEDGE_FOLDER.PATH')}}
                              v-col.pa-0(cols='8' :title='parentFolderPath')
                                  v-text-field(
                                    v-model='parentFolderPath'
                                    outlined
                                    dense
                                    readonly
                                    @click='openParentFolderPicker'
                                    style='font-weight: 500; font-size: 14px;'
                                  )
                              v-col.pa-0(cols='2')
                                  div.ml-3
                                    v-progress-circular(v-if='moveLoading' size='18' indeterminate color='primary')
                                    v-btn.pa-0(v-else plain ripple style='width:40px; height:28px;' @click='openParentFolderPicker')
                                      v-img(src="@/assets/images/folder-btn.svg" max-height="30" max-width="30")
                          // 文件總數 + 最後更新 (同一列)
                          .d-flex.align-start.t-gray.mt-2
                            p.d-flex.align-center.pt-2.mb-0.mr-12(:title='knowledgeData.docs_count' style='white-space:nowrap;') {{$t("GPT_KNOWLEDGE.DOCS")}} :
                              span.span.ml-2 {{knowledgeData.docs_count}}
                            p.d-flex.align-center.justify-center.pt-2(style='white-space:nowrap;') {{$t("GPT_KNOWLEDGE.LAST_UPDATED")}} :
                              v-list-item
                                v-list-item-avatar.ma-0.mr-2.knowledges-avatar-32(color='aliceBlue')
                                  span.span(v-if="knowledgeData.updated_by.usersetting.photo === ''") {{ knowledgeData.updated_by.last_name }}
                                  img(v-else :src="knowledgeData.updated_by.usersetting.photo" :alt="knowledgeData.updated_by.usersetting.last_name" )
                                v-list-item-content.pa-0.user_icon
                                    span.t-gray(class='name ellipsis') {{knowledgeData.updated_by.last_name+" "}}{{knowledgeData.updated_by.first_name}}
                                    span(class='small_word_gray ellipsis' ) {{getFormatTime(knowledgeData.updated_on)}}
                // 系統操作區(右側)
                v-col(cols='6')
                  .knowledges-detail-subcard.pr-5
                    v-card.rounded-card(flat style='height:100%;')
                      v-card-title.pa-0.pt-1.d-flex.align-center.justify-md-space-between
                        div.pa-2.d-flex.align-center(width="30px")
                          v-img.ml-2(id='' src="@/assets/images/botsetting.png" class="white--text align-end"  width="40px")
                          h5.f-text-highlight-word.ellipsis.pl-3.pt-3 {{$t("GPT_KNOWLEDGE.SETTING")}}
                      .pa-0.pt-0.d-flex.justify-md-space-between
                        v-card-text.pt-4(style='padding-left:25px;')
                          // 開關知識庫
                          div.mb-4
                            v-icon mdi-power
                            span.pl-1 {{$t("GPT_KNOWLEDGE.ONOFF")}} :
                            label.ml-3.mr-3(class="switch")
                              input(v-model='knowledgeData.active' type="checkbox" @click='openKnowledge(knowledgeData)' :disabled='$isViewOnly.isViewOnly')
                              div(class="slider round")
                          // 共用知識庫
                          div.mb-4(v-if="isAdmin && !is_private" )
                            v-icon(size='18').pb-1 mdi-share-variant
                            span.pl-2.mt-1 {{$t("GPT_KNOWLEDGE.PUBLIC")}} :
                            label.ml-3.mr-3(class="switch")
                              input(v-model='knowledgeData.ispublic' type="checkbox" @click='isPublicKnowledge(knowledgeData)' :disabled='$isViewOnly.isViewOnly')
                              div(class="slider round")
                          // 清空知識庫
                          div.mb-4
                            v-icon(size='22').pb-1 mdi-broom
                            span.pl-1.mt-1 {{$t("GPT_KNOWLEDGE.CLEAR_ALL")}} :
                              label.ml-3.mr-3(class="switch")
                                v-btn.btn_green.ml-3(:disabled='$isViewOnly.isViewOnly' @click='resetData' width='' height='24' :ripple='false'  depressed dark )
                                  span {{$t("GPT_KNOWLEDGE.CLEAR")}}
                          // 刪除知識庫
                          div(v-if='isAdmin || is_private')
                            v-icon(size='16').pb-1 icon-remove
                            span.pl-1.mt-1 {{$t("GPT_KNOWLEDGE.DELETE")}} :
                              label.ml-3.mr-3(class="switch")
                                v-btn.btn_red.ml-3(:disabled='$isViewOnly.isViewOnly' @click='onDelete' width='' height='24' :ripple='false'  depressed dark )
                                  span {{$t("GENERAL.DELETE")}}
                      // 編輯連結機器人
                      v-row.pt-1(no-gutters v-if='!loading && !isEditSub && isAdmin && !is_private' style='margin-left:27px;')
                        //- v-col.ma-0(cols='1',style='display:flex; justify-content:center;')
                        v-col.d-flex(cols='auto',style="font-size:14px;")
                          v-img.my-0.ml-0(src='@/assets/images/ai_bot.png' max-width=20 max-height=20 style='margin-right:7px;')
                          span.ml-0 {{$t("GPT_KNOWLEDGE.LINKBOT")}} :
                          span.ml-0(v-if='knowledgeData.ispublic') {{$t("GPT_KNOWLEDGE.ISPUBLIC")}}
                          span.ml-0(v-else) {{knowledgeData.robots === null? $t("GPT_KNOWLEDGE.NO_LINKBOT"): getChatBotName()}}
                        v-col(cols='1' v-if='!knowledgeData.ispublic')
                          v-btn.pb-1(height='15' icon text color='gary' @click='onEditSub' v-if='!isEditSub')
                            v-icon(size='15') icon-edit
                      p(v-else-if="(loading || isEditSub) && !is_private" style='margin-left:15px;').d-flex.align-center.knowledge-subcard-input
                        label.pr-4 {{$t("GPT_KNOWLEDGE.LINKBOT")}} :
                        v-autocomplete.no-border(v-model='knowledgeData.robots' return-object multiple solo :readonly='!isEditSub' :class='!isEditSub ? "remove-arrow" : ""' :items='chatBotList' item-text='bot_name' item-value='id'  :menu-props='{closeOnClick:true}')
                          template(v-slot:append-outer)
                            v-icon.mr-1(size='18' color="green" v-if='isEditSub' @click='confirmEditDetailSub()') icon-check
                            v-icon(size='18' color="red" v-if='isEditSub' @click='cancelEditDetailSub()') mdi-window-close
                            v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
      // 權限設定區
      #page-inner.pa-3.pt-5.d-flex.justify-center(v-if='!loading && !is_private')
        instancePermissionCard(:key='permissionCardKey' :instance_id='KB_id', model_type='KNOWLEDGE')                   
      // 知識庫上傳區
      #page-inner.pa-3.pt-5.d-flex.justify-center(v-if='!loading')
        knowledgeTabs(ref='knowledgeTabs',:target_id='target_id', :knowledge_name='knowledgeData.name' :is_private="is_private" @emitreFresh='reFresh' @emitCount='reCount' @emitChangeTab='goRecord')

    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='parentFolderPickerDialog' width='680' content-class='statusDialog' v-if='parentFolderPickerDialog')
      folder-location-picker-dialog(v-model='parentFolderPickerDialog' :selected-id='knowledgeData.parent_folder || "Root"' @confirm='onParentFolderPicked' @cancel='parentFolderPickerDialog = false')
    v-dialog(v-model='applyPermissionDialog' width='360' content-class='statusDialog' v-if='applyPermissionDialog')
      message-apply-dialog(@emitMessageDialog='onEmitApplyPermissionDialog' :message='applyPermissionMessage')
</template>
<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from '/common/plugins/vue-i18n.js';
import knowledgeTabs from "../components/GPT_Common/KnowledgeTabs.vue";
import instancePermissionCard from "../components/GPT_Common/instancePermissionCard.vue";
import folderLocationPickerDialog from "@/components/GPT_Dialog/Knowledge/folderLocationPickerDialog";
import messageApplyDialog from "@/components/Dialog/messageApplyDialog.vue";
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import AiBotsService from "../services/AiBotsService";

export default {
    props:{
        is_private: {
            type: Boolean,
            default: () => false,
        },
        target_id: {
          type: String,
          default: ''
        },
    },
    components: {
        loadingOverlay,
        messageDialog,
        successDialog,
        errorDialog,
        knowledgeTabs,
        instancePermissionCard,
        folderLocationPickerDialog,
        messageApplyDialog,
    },
  data() {
    return {
      // other
      valid:true,
      isEdit:false,
      isEditSub:false,
      loading:false,
      delLoading:false,
      breadcrumbs: [{
              text: i18n.t('GPT_MENU.BACKTO') + i18n.t('GPT_KNOWLEDGE.TITLE'),
              disabled: false,
              href: '/upgpt/Knowledges',
          }
      ],
      formRule: {
        categoryRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30')
        ],
        nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
        ],
        system_nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => /^[a-zA-Z0-9_]+$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'), // 只能輸入英文字母和數字與底線
          (v) => (v.length <= 30) || i18n.t('RULE.RULE_30')  // 最多 30 個字
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/s.test(v) || i18n.t('RULE.RULE_100')
        ],
      },
      // Dialog
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      // Data
      isAdmin: false,
      knowledgeData:null,
      originKnowledgeData:null,
      chatBotList:[],
      chatBotName:"",
      mode:null,
      category_list: [],
      KB_id: this.$route.params.id,
      // 父層（搬移知識庫）
      folder_mode: false,
      parentFolderPath: "/",
      parentFolderPickerDialog: false,
      applyPermissionDialog: false,
      applyPermissionMessage: "",
      pendingParentFolder: null,   // { id, path } 選好但尚未送出的目標資料夾
      moveLoading: false,
      permissionCardKey: 0,
    };
  },
  async created() {
    this.loading = true;
    this.checkAdmin();
    await this.default_target_id();
    await this.getBotList();
    await this.getDetailData();
    await this.initParentFolder();
    await KnowledgeLibraryService.getknowledgecategoryoption().then((response)=>{
      this.category_list = response.data;
    });
    this.loading = false;
  },
  destroyed() {
  },
  computed: {
    isSystemNameAndDescriptionValid() {
      if (this.formRule.system_nameRules.every(rule => rule(this.knowledgeData.system_name) === true) 
      && this.formRule.descriptionRules.every(rule => rule(this.knowledgeData.description) === true)
      && this.formRule.categoryRules.every(rule => rule(this.knowledgeData.category) === true)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    checkAdmin(){
      let userJson = window.localStorage.getItem('user');
      let user = JSON.parse(userJson);
      user.is_staff ? this.isAdmin = true : this.isAdmin = false;
    },
    default_target_id(){
      if (this.target_id ===''){
          this.target_id = this.$route.params.id;
      }
    },
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    goRecord() {
      this.$router.replace('/upgpt/Uploadrecord');
    },
    set_title(){
        const title = localStorage.getItem('title');
        let title_name = this.knowledgeData.display_name;
        let tab_name = '';
        tab_name = this.knowledgeData.display_name;
        document.title = title+' : '+title_name +' – UpGPT';
        return tab_name;
    },
    async getDetailData() {
      await KnowledgeLibraryService.detail(this.target_id,this.is_private).then((response) => {
        let data = response.data;
        data.robots = data.linked_bots_and_knowledge_set.map(item => {return item.ai_bot_id});
        data.robots_count = data.linked_bots_and_knowledge_set.length;
        data.docs_count = data.knowledge_detial_set.length;
        data.display_name = data.name.replace(/@.*$/, "");
        this.knowledgeData = response.data;
        this.set_title();
      }).catch(response => {
        // Redirect to PermissionError page if error status is 403
        if (response.response.status == 403) {
          this.$router.replace('/upgpt/PermissionError');
        } else if (response.response.status == 404) {
          this.$router.replace('/upgpt/PageNotFound');
        }
      });
    },
    async getBotList() {
      await AiBotsService.select_list().then((response) => {
        this.chatBotList = response.data;
      })
    },
    async openKnowledge(data) {
      if (this.$isViewOnly.isViewOnly) return;
      let edit_data = {
        "id": data.id,
        "active": !data.active
      }
      await KnowledgeLibraryService.edit(edit_data,this.is_private).then((response) => {
        data.active = response.data.active;
      })
    },
    async isPublicKnowledge(data) {
      if (this.$isViewOnly.isViewOnly) return;
      let edit_data = {
        "id": data.id,
        "ispublic": !data.ispublic
      }
      await KnowledgeLibraryService.edit(edit_data,this.is_private).then((response) => {
        data.is_public = response.data.ispublic;
      })
    },
    onDelete() {
      this.mode = "delete";
      this.message = i18n.t("GPT_KNOWLEDGE.DEL_MSG");
      this.messageDialog = true;
    },
    resetData(){
      this.mode = "reset";
      this.message = i18n.t("GPT_KNOWLEDGE.CLEAR_MSG");
      this.messageDialog = true;
    },
    getChatBotName(){
      let names = " " + this.knowledgeData.robots.map(el=>{return el.bot_name}).join();
      return names
    },
    getFormatTime(data){
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
        let today  = new Date(data);
        if(this.$i18n.locale == "zh_TW")
        {
            return today.toLocaleDateString("zh-TW", options); 
        }else
        {
            return today.toLocaleDateString("en-US", options);
        }
    },
    onEdit(){
        this.isEdit = true;
        this.originKnowledgeData = JSON.parse(JSON.stringify(this.knowledgeData));
    },
    async confirmEditDetail(){
      if (this.validateForm() && this.isEdit){
        if (typeof this.knowledgeData.category === 'object' && this.knowledgeData.category !== null) {
          this.knowledgeData.category =  this.knowledgeData.category.name;
        }
        let edit_data = {
          "id" : this.knowledgeData.id,
          "description" : this.knowledgeData.description,
          "system_name" : this.knowledgeData.system_name,
          "category" : this.knowledgeData.category,
        }
        await KnowledgeLibraryService.edit(edit_data,this.is_private).then((response)=>{
          this.knowledgeData.description = response.data.description;
          this.knowledgeData.system_name = response.data.system_name;
          this.knowledgeData.updated_on = response.data.updated_on;
          this.knowledgeData.category = response.data.category;
          this.isEdit = false;
        })
        .catch((error) => {
          // Redirect to PermissionError page if error status is 403
          if (error.response.status == 400) {
            this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.SYSTEM_NAME_ERROR'));
          }
        });
        await KnowledgeLibraryService.getknowledgecategoryoption().then((response)=>{
          this.category_list = response.data;
        });
      }
    },
    cancelEditDetail(){
      this.isEdit = false;
      this.knowledgeData = this.originKnowledgeData;
    },
    onEditSub(){
        this.isEditSub = true;
        this.originKnowledgeData = JSON.parse(JSON.stringify(this.knowledgeData));
    },
    async confirmEditDetailSub(){
      let edit_data = {
        "id" : this.knowledgeData.id,
        "linked_ai_bot" : this.knowledgeData.robots,
      }
      await KnowledgeLibraryService.set_detail_bots(edit_data).then((response)=>{
        this.knowledgeData.robots = response.data.linked_ai_bot;
        this.knowledgeData.updated_on = response.data.updated_on;
      })
      this.isEditSub = false;
    },
    cancelEditDetailSub(){
      this.isEditSub = false;
      this.knowledgeData = this.originKnowledgeData;
    },
  async initParentFolder() {
    if (this.is_private || !this.knowledgeData) return;
    const setting = await this.upgpt_image_func_setting();
    this.folder_mode = !!(setting && setting['knowledge_folder']);
    if (this.folder_mode) {
      await this.loadParentFolderPath();
    }
  },
  async loadParentFolderPath() {
    this.parentFolderPath = "/";
    const pid = this.knowledgeData && this.knowledgeData.parent_folder;
    if (!pid) return;
    try {
      const res = await KnowledgeLibraryService.getFolderTree();
      const tree = (res.data && res.data.tree) || [];
      const find = (nodes, base) => {
        for (const n of nodes) {
          if (!n || n.type !== 'folder') continue;
          const path = base === '/' ? `/${n.name}` : `${base}/${n.name}`;
          if (String(n.id) === String(pid)) return path;
          const found = find(n.children || [], path);
          if (found) return found;
        }
        return null;
      };
      this.parentFolderPath = find(tree, '/') || '/';
    } catch (e) {
      this.parentFolderPath = '/';
    }
  },
  openParentFolderPicker() {
    if (!this.moveLoading) this.parentFolderPickerDialog = true;
  },
  onParentFolderPicked({ id, path }) {
    this.parentFolderPickerDialog = false;
    const target = (!id || id === "Root") ? null : id;
    const current = this.knowledgeData.parent_folder || null;
    if (String(target) === String(current)) {
      this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.MOVE_SAME_LOCATION'));
      return;
    }
    this.pendingParentFolder = { id: target, path: path || '/' };
    if (target === null) {
      this.moveToParentFolder(false);
    } else {
      this.applyPermissionMessage = i18n.t('GPT_KNOWLEDGE.UPDATE_FOLDER_PERMISSION');
      this.applyPermissionDialog = true;
    }
  },
  onEmitApplyPermissionDialog(val) {
    this.applyPermissionDialog = false;
    this.moveToParentFolder(val);
  },
  async moveToParentFolder(applyPermission) {
    if (!this.pendingParentFolder) return;
    const { id, path } = this.pendingParentFolder;
    this.moveLoading = true;
    await KnowledgeLibraryService.moveLibrary(this.knowledgeData.id, id, applyPermission).then(() => {
      this.knowledgeData.parent_folder = id;
      this.parentFolderPath = path;
      if (applyPermission) {
        this.permissionCardKey += 1;
      }
      this.showSuccessDialog();
    }).catch(error => {
      const status = error.response && error.response.status;
      this.showErrorDialog(status === 403 ? i18n.t('GPT_KNOWLEDGE.MOVE_NO_PERMISSION') : i18n.t('GPT_KNOWLEDGE.MOVE_FAIL'));
    }).finally(() => {
      this.moveLoading = false;
      this.pendingParentFolder = null;
    });
  },
    onMail: function (mail) {
      return "mailto:" + mail;
    },
    // Dialog Area ----------------------------------------- [Start]
    
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      if (this.mode == 'delete') {
        this.mode = null;
        this.$router.push('/upgpt/Knowledges');
      }
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val){
        this.delLoading = true;
        this.messageDialog = false;
        if(this.mode == "delete"){
          await KnowledgeLibraryService.delete(this.target_id,this.is_private).then(()=>{
            this.$router.push('/upgpt/Knowledges');
            this.delLoading = false;
            this.mode = null;
          }).catch(() => {
              this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.DELETE_ERROR'));
              this.delLoading = false;
          });
        }else if(this.mode == "reset"){
          await KnowledgeLibraryService.clear_knowledge(this.target_id).then(()=>{
            this.$refs.knowledgeTabs.getKnowledgeInfo();
            this.delLoading = false;
            this.mode = null;
          }).catch(() => {
            this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.CLEAR_ERROR'));
            this.delLoading = false;
            this.mode = null;
          });
        }
      }
      this.messageDialog = false;
    },
    async reFresh() {
      this.loading = true;
      await this.getDetailData();
      this.loading = false;
    },
    reCount() {
      this.knowledgeData.docs_count = this.knowledgeData.docs_count - 1;
    }
  },
  watch: {}
};
</script>
<style>
.hint-style{
  margin-bottom: 2px !important;
}
.hint-style .v-messages__message{
  line-height: 130%;
  padding-bottom: 2px !important;
  margin-top: 2px !important;
}
</style>
 